export default __webpack_public_path__ + "static/media/logo.deb0419d.png";